import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _SpecialFolderId;
/** 查询分页列表结构的参数规范 */

/** 查询分页列表结构的结果 */

export var MY_DOC_FOLDER_ID = 'my_doc';
export var SHARED_FOLDER_ID = 'shared';
export var RECENT_FOLDER_ID = 'recent';
export var COLLECT_FOLDER_ID = 'collect';
export var TRASH_FOLDER_ID = 'trash';
export var STORAGE_FOLDER_ID = 'storage';
export var CACHE_FOLDER_ID = 'cache';
export var LOCAL_FILE_FOLDER_ID = 'local';
export var BUSINESS_SPACE_FOLDER_ID = 'business_space';
export var SAFE_FOLDER_ID = 'safe';
export function isSpecialFolderId(id) {
  return [MY_DOC_FOLDER_ID, SHARED_FOLDER_ID, RECENT_FOLDER_ID, COLLECT_FOLDER_ID, TRASH_FOLDER_ID, STORAGE_FOLDER_ID, CACHE_FOLDER_ID, LOCAL_FILE_FOLDER_ID, BUSINESS_SPACE_FOLDER_ID, VAGUE_ROOT_ID, VAGUE_SPACES_ID, SAFE_FOLDER_ID].includes(id);
}

/**
 * drive 应用里所有列表根文件夹的名字，帮助 SpecialFolderId 的 key 和 value 做映射，保证新增特殊目录时改代码不会改漏
 *
 * 与 drive 的目录设计有关
 */
export var SpecialFolderName = /*#__PURE__*/function (SpecialFolderName) {
  SpecialFolderName["MyDoc"] = "MyDoc";
  SpecialFolderName["Shared"] = "Shared";
  SpecialFolderName["Recent"] = "Recent";
  SpecialFolderName["Collection"] = "Collection";
  SpecialFolderName["Trash"] = "Trash";
  SpecialFolderName["Storage"] = "Storage";
  SpecialFolderName["Cache"] = "Cache";
  SpecialFolderName["LocalFile"] = "LocalFile";
  SpecialFolderName["BusinessSpace"] = "BusinessSpace";
  SpecialFolderName["Safe"] = "Safe";
  return SpecialFolderName;
}({});

/**
 * drive 应用里所有列表根目录的文件夹 ID，离线缓存列表和本地文件列表是后台没有的
 *
 * 与 drive 的目录设计有关
 *
 * !!! 注意后台的最近浏览 id 为 browse，而前端历史代码里为 recent，接口若返回 browse 请进行转换 !!!
 */
export var SpecialFolderId = (_SpecialFolderId = {}, _defineProperty(_SpecialFolderId, SpecialFolderName.MyDoc, MY_DOC_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Shared, SHARED_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Recent, RECENT_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Collection, COLLECT_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Trash, TRASH_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Storage, STORAGE_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Cache, CACHE_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.LocalFile, LOCAL_FILE_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.BusinessSpace, BUSINESS_SPACE_FOLDER_ID), _defineProperty(_SpecialFolderId, SpecialFolderName.Safe, SAFE_FOLDER_ID), _SpecialFolderId);

/** 仅在转换为后台接口参数时用到，前端业务逻辑请使用 folderID 或 SpecialFolderID */
export var VAGUE_ROOT_ID = '/';
export var VAGUE_SPACES_ID = 'spaces';
export function specialFolderId2VagueId(id) {
  if (id === MY_DOC_FOLDER_ID) return VAGUE_ROOT_ID;
  if (id === BUSINESS_SPACE_FOLDER_ID) return VAGUE_SPACES_ID;
  return id;
}

/** 排序规则 */

/** 排序依据的字段 */
export var OrderBy = /*#__PURE__*/function (OrderBy) {
  OrderBy["ModifyTime"] = "ModifyTime";
  OrderBy["AccessTime"] = "AccessTime";
  OrderBy["Name"] = "Name";
  OrderBy["CreateTime"] = "CreateTime";
  return OrderBy;
}({});

/** uid 不方便表示的来源 */
export var SpecialSource = /*#__PURE__*/function (SpecialSource) {
  SpecialSource["Mine"] = "Mine";
  SpecialSource["Others"] = "Others";
  return SpecialSource;
}({});
//# sourceMappingURL=list-query.js.map